import { defineMessages } from 'react-intl';

const _default_1: {
	label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	label: {
		id: 'fabric.editor.ai.screens.prompt.mentionButton.label',
		defaultMessage: 'Mention someone or a team',
		description: 'Mention button label within the Prompt screen',
	},
});
export default _default_1;
